import ROLE from "../../../modules/role";
import { useContext, useEffect, useState } from "react";
import AppUserContext from "../../../context/app-user-context";
import SeparatorToNewLine from "../../../components/static/SeparatorToNewLine";

export default function PageProfile_Supervisor() {
  const user = useContext(AppUserContext);
  let [programme, setProgramme] = useState("-");
  let [cohort, setCohort] = useState("-");

  useEffect(() => {
    if (!user) {
      return;
    }

    const programmeList = [];
    const cohortList = [];

    Object.keys(user.groupHash).forEach((group) => {
      const programmeName = user.groupHash[group]?.cohort?.programme;
      const cohortName = { ...user.groupHash[group].cohort };

      if (programmeList.indexOf(programmeName?.name) === -1) {
        programmeList.push(programmeName?.name);
      }

      if (cohortList.indexOf(cohortName?.name) === -1) {
        cohortList.push(cohortName?.name);
      }
    });

    setProgramme(programmeList.length > 0 ? programmeList.join(", ") : "-");
    setCohort(cohortList.length > 0 ? cohortList.join(", ") : "-");
  }, []);

  return <>
    <div className="mgr__profile-details mgr__profile-details--wide">
      <div>
        <h1 className="mgr__profile-details__title d-none">My Profile</h1>
        <div className="mgr__profile-details__info">
          <p className="label">Name</p>
          <span className="separator">:</span>
          <p className="value value--normal">{user?.name ?? "-"}</p>

          <p className="label">{user?.role === ROLE.SUPERVISOR ? "SIT ID" : "Email"}</p>
          <span className="separator">:</span>
          <p className="value value--normal">{ user?.email ?? "-" }</p>

          {
            user?.role === ROLE.SUPERVISOR &&
            <>
              <p className="label">SIT Email Address</p>
              <span className="separator">:</span>
              <p className="value value--normal">{ user?.nameEmail ?? "-" }</p>
            </>
          }

          <p className="label">Programmes you are supervising</p>
          <span className="separator">:</span>
          <div className="value value--normal">
            <SeparatorToNewLine value={programme} />
          </div>

          <p className="label">Cohorts you are supervising</p>
          <span className="separator">:</span>
          <div className="value value--normal">
            <SeparatorToNewLine value={cohort} />
          </div>
        </div>
      </div>
    </div>
  </>;
}
